export * from './unordered-list-one-config.interface';
